import { Alert, Box, Button, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type OnboardingStepImportProps = {
  onNavigateAway?: () => void;
};

export const OnboardingStepImport = ({ onNavigateAway }: OnboardingStepImportProps) => {
  const { t } = useTranslation(['onboarding']);

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Box sx={{ p: 2, position: 'sticky', top: 0, alignSelf: 'flex-start' }}>
            <Typography variant='body1' sx={{ mb: 2 }}>
              {t('onboarding:stepContent.import.description')}
            </Typography>
            <Typography variant='body2' color='text.secondary' sx={{ mb: 2 }}>
              {t('onboarding:stepContent.import.hint')}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={8}>
          <Box sx={{ bgcolor: '#fff', borderRadius: 1, p: 2, border: 1, borderColor: 'grey.300', boxShadow: '0 2px 8px rgba(0,0,0,0.10)' }}>
            <Alert severity='warning'>
              {t('onboarding:stepContent.import.editHint')}{' '}
              <Button
                variant='text'
                size='small'
                sx={{
                  p: 0,
                  minWidth: 0,
                  textTransform: 'none',
                  fontWeight: 600,
                  verticalAlign: 'baseline',
                  fontSize: 'inherit',
                  lineHeight: 'inherit',
                }}
                onClick={() => {
                  if (onNavigateAway) onNavigateAway();
                }}
              >
                {t('onboarding:stepContent.import.editLink')}
              </Button>
              .
            </Alert>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
